import Toastify from "toastify-js";

export function initLoginErrors() {
  const containerElement = document.querySelector("#js-login-errors");
  if (!containerElement) return;

  let initialProps = [];
  try {
    initialProps = JSON.parse(
      containerElement.getAttribute("data-initial-props")
    );
  } catch (error) {
    console.error(
      error,
      "Could not parse initial props JSON for initLoginErrors"
    );
  }

  if (Array.isArray(initialProps) && initialProps.length) {
    initialProps.forEach((error) => {
      const spanWrapper = document.createElement("span");
      spanWrapper.classList.add("login-errors-notification-text");
      spanWrapper.textContent = error;

      Toastify({
        node: spanWrapper,
        duration: 5000,
        close: true,
        gravity: "bottom",
        position: "center",
        className: "login-errors-notification",
        offset: {
          x: "50%",
          y: "50px",
        },
        stopOnFocus: true,
      }).showToast();
    });
  }
}
